import ChatTabsContainer from './ChatTabsContainer';

export default ChatTabsContainer;
